// extracted by mini-css-extract-plugin
export var progressContainer = "_ib-0";